<template>
  <snt-loading
    :loading="$apollo.loading"
    min-height="60px"
    class="order-contact-method">
    <div class="flex items-center gap-2">
      <text-field-label
        label="กำหนดช่องทางจำหน่ายเอง" />
      <div>
        <v-progress-circular
          v-if="loading"
          size="16"
          width="2"
          indeterminate />
        <transition
          v-else
          name="fade">
          <v-img
            v-show="icon && !isTimeout"
            class="w-4"
            :src="icon"
            height="16"
            eager
            contain />
        </transition>
      </div>
    </div>
    <div>
      <v-autocomplete
        v-model="contactMethods"
        :items="allItems"
        :search-input.sync="searchText"
        :menu-props="{
          nudgeTop: '-4px',
          contentClass:'snt-tag-suggestions__content'
        }"
        :append-icon="contactMethods.length ? '' : undefined"
        :disabled="loading"
        item-text="description"
        item-value="name"
        label="เลือกช่องทางจำหน่าย"
        placeholder="เลือกช่องทางจำหน่าย"
        hide-details
        multiple
        hide-selected
        hide-no-data
        outlined
        dense
        chips
        solo
        flat
        @keydown.enter="addOther($event)"
        @change="submitDebounce($event)">
        <template #selection="{ attrs, select, item, index }">
          <v-chip
            v-bind="attrs"
            class="ma-1"
            color="primary"
            outlined
            label
            small
            close
            @click="select"
            @click:close="remove(index)">
            {{ item.description }}
          </v-chip>
        </template>
        <template #item="{ item }">
          <div class="d-flex align-center">
            <v-img
              v-if="$_.has(item, 'image')"
              :width="24"
              :height="24"
              :src="item.image"
              class="mr-3 rounded"
              contain />
            <span>{{ item.description }}</span>
          </div>
        </template>
      </v-autocomplete>
    </div>
  </snt-loading>
</template>

<script>
import { GET_ORDERCONTACTMETHOD_ENUM, GET_ORDER_CONTACT_METHOD, UPDATE_SETTING } from '@/resources/graphql'
import channelData from '@/resources/json/channel'

export default {
  apollo: {
    contactMethodEnums: {
      query: GET_ORDERCONTACTMETHOD_ENUM,
      update ({ __type: { enumValues } }) {
        return enumValues.map((value) => {
          const contact = channelData.find((channel) => this.$_.toLower(channel.value) === this.$_.toLower(value.name))
          return {
            ...value,
            image: contact?.image
          }
        })
      }
    },
    orderContactMethods: {
      query: GET_ORDER_CONTACT_METHOD,
      update ({ setting: { orderContactMethods } }) {
        return orderContactMethods
      },
      result ({ data: { setting: { orderContactMethods } } }) {
        this.contactMethods = this.$_.cloneDeep(orderContactMethods)
      }
    }
  },
  data () {
    return {
      state: 'ready',
      contactMethodEnums: [],
      contactMethods: [],
      searchText: '',
      timeOut: null,
      isTimeout: false
    }
  },
  computed: {
    loading () {
      return this.state === 'loading'
    },
    icon () {
      switch (this.state) {
      case 'success':
        return `${process.env.VUE_APP_ROUTE_PREFIX}imgs/icon/correct_icon.gif?fid=${ Math.random(10000) }`
      case 'error':
        return `${process.env.VUE_APP_ROUTE_PREFIX}imgs/icon/correct_icon.gif?fid=${ Math.random(10000) }`
      default: return null
      }
    },
    isError () {
      return this.state === 'error'
    },
    color () {
      switch (this.state) {
      case 'ready':
      case 'loading':
        return 'primary'
      case 'success':
        return 'success'
      case 'error':
        return 'error'
      default: return 'primary'
      }
    },
    allItems () {
      const contactMethods = this.contactMethods.filter((contactMethod) => (
        !this.$_.find(this.contactMethodEnums, { name: contactMethod })
      )).map((contactMethod) => (
        {
          name: contactMethod,
          description: contactMethod
        }
      ))
      return [...this.contactMethodEnums, ...contactMethods]
    }
  },
  watch: {
    state (value) {
      if (value === 'success') {
        clearTimeout(this.timeOut)
        this.timeOut = setTimeout(() => {
          this.isTimeout = true
        }, 3000)
      } else {
        this.isTimeout = false
      }
    }
  },
  created () {
    this.submitDebounce = this.$_.debounce(this.submit, 1000)
  },
  methods: {
    submit () {
      this.state = 'loading'
      this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            orderContactMethods: this.contactMethods
          }
        }
      }).then(({ data: { updateSetting: { setting } } }) => {
        this.state = 'success'
        this.contactMethods = setting.orderContactMethods
      }).finally(() => {
        setTimeout(() => {
          this.state = 'ready'
        }, 1500)
      })
    },
    addOther (e) {
      const values = this.$_.cloneDeep(this.contactMethods)
      const value = e.target.value
      if (!values.includes(value)) {
        values.push(value)
        this.contactMethods = values
        this.submitDebounce()
      }
      this.searchText = ''
    },
    remove (index) {
      const values = this.$_.cloneDeep(this.contactMethods)
      values.splice(index, 1)
      this.contactMethods = values
      this.submitDebounce()
    }
  }
}
</script>

<style>

</style>

<style lang="scss" scoped>
.snt-tag-suggestions {
  &__content {
    > .v-select-list {
      &.v-list {
        padding: 8px 4px;
        ::v-deep {
          overflow-y: auto;
          max-height: 304px;
          .v-list-item {
            margin-bottom: 4px;
            border-radius: 4px;
            &::before {
              border-radius: 4px;
            }
            &:hover::before {
              opacity: 0.1;
            }
            &.v-list-item--link:hover {
              color: var(--v-primary-base) !important;
            }
            .v-list-item__title {
              font-size: 1rem !important;
              font-style: normal;
              font-weight: normal;
              line-height: 24px;
            }
          }
        }
      }
    }
  }
}
.order-contact-method {

  .v-chip {
    &.v-chip--outlined {
      background-color: var(--v-select-base) !important;
    }
  }
}
</style>
